import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function AgeCard() {
  const [distribution, setDistribution] = useState({
    "18-24": 0,
    "25-34": 0,
    "35-44": 0,
    "45+": 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadAgeDistribution() {
      try {
        const snap = await getDocs(collection(db, "users"));

        let ranges = {
          "18-24": 0,
          "25-34": 0,
          "35-44": 0,
          "45+": 0,
        };

        let total = 0;
        const currentYear = new Date().getFullYear();

        snap.forEach((doc) => {
          const data = doc.data();
          const birthDate = data.birthDate;

          if (!birthDate || !birthDate.seconds) return;

          const birthYear = new Date(birthDate.seconds * 1000).getFullYear();
          const age = currentYear - birthYear;

          if (age < 18 || age > 100) return; // ignora dados inesperados

          total++;

          if (age <= 24) ranges["18-24"]++;
          else if (age <= 34) ranges["25-34"]++;
          else if (age <= 44) ranges["35-44"]++;
          else ranges["45+"]++;
        });

        // Calcula porcentagens
        const percent = total
          ? {
              "18-24": Math.round((ranges["18-24"] / total) * 100),
              "25-34": Math.round((ranges["25-34"] / total) * 100),
              "35-44": Math.round((ranges["35-44"] / total) * 100),
              "45+": Math.round((ranges["45+"] / total) * 100),
            }
          : ranges;

        setDistribution(percent);
      } catch (error) {
        console.error("Erro ao carregar distribuição de idade:", error);
      } finally {
        setLoading(false);
      }
    }

    loadAgeDistribution();
  }, []);

  if (loading) {
    return (
      <div className="metric-card">
        <p className="metric-label">Faixa etária</p>
        <p className="metric-value">Carregando...</p>
        <span className="metric-tag">Distribuição estimada</span>
      </div>
    );
  }

  return (
    <div className="metric-card">
      <p className="metric-label">Faixa etária</p>

      <div className="metric-list">
        <div className="metric-list-item">18-24: {distribution["18-24"]}%</div>
        <div className="metric-list-item">25-34: {distribution["25-34"]}%</div>
        <div className="metric-list-item">35-44: {distribution["35-44"]}%</div>
        <div className="metric-list-item">45+: {distribution["45+"]}%</div>
      </div>

      <span className="metric-tag">Distribuição estimada</span>
    </div>
  );
}
